import { required, minLength, email, helpers } from 'vuelidate/lib/validators'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { parse, compareAsc } from 'date-fns'
import { isLessThanToday, isDateLessThan } from '~/validations/validations.js'

import Form from '~/utils/mixins/form'

const phoneRule = helpers.withParams({ async: true }, (value, countryCode) => {
  return new Promise((resolve) => {
    const phoneNumber = countryCode + value // full phone number = countryCode+Value
    const parsedNumber = parsePhoneNumberFromString(phoneNumber) // now we can validate the full phone number

    resolve(parsedNumber ? parsedNumber.isValid() : false)
  })
})

const isAtLeastNextDayRule = helpers.withParams({ async: true }, (value) => {
  return new Promise((resolve) => {
    if (!value) {
      resolve(false)
    }
    const parsedDate = parse(value, 'dd/MM/yyyy', new Date())

    const today = new Date()
    const nextDay = new Date(today)
    nextDay.setDate(today.getDate() + 1)
    if (!isNaN(parsedDate)) {
      if (compareAsc(parsedDate, nextDay) === 1) {
        resolve(true)
      } else {
        resolve(false)
      }
    } else {
      resolve(false)
    }
  })
})

const isSecondDateGreaterThanFirstRule = helpers.withParams(
  { async: true },
  (firstDate, secondDate) => {
    return new Promise((resolve) => {
      const firstDateParsed = parse(firstDate, 'dd/MM/yyyy', new Date())

      const secondDateParsed = parse(secondDate, 'dd/MM/yyyy', new Date())

      if (!isNaN(firstDateParsed) || !isNaN(secondDateParsed)) {
        if (compareAsc(secondDateParsed, firstDateParsed) === 1) {
          resolve(true)
        } else {
          resolve(false)
        }
      } else {
        resolve(false)
      }
    })
  }
)
const sameAs = (value) => value === true
export default {
  mixins: [Form],
  components: {
    InputBlock: () => import('~/components/commom/input-block/index'),
    ErrorBlock: () => import('~/components/commom/error-block/index'),
    DateBlock: () => import('~/components/commom/date-block/index'),
    RadioBlock: () => import('~/components/commom/radio-block/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    CheckboxBlock: () => import('~/components/commom/checkbox-block/index'),
    SelectBlock: () => import('~/components/commom/select-block/index')
  },
  data() {
    return {
      fullName: '',
      email: '',
      phone: '',
      applicantDateOfBirth: null,
      secondApplicantDateOfBirth: null,
      location: '',
      countryCode: '+351',
      duration: null,
      start_date: null,
      end_date: null,
      isCountryCode: true,
      privacyPolicy: false,
      termsAndConditions: false,
      country: null,
      options: {
        portugueseCountriesArray: [
          { name: 'Afeganistão', value: 'Afeganistão' },
          { name: 'Samoa Americana', value: 'Samoa Americana' },
          { name: 'Anguilla', value: 'Anguilla' },
          { name: 'Antártida', value: 'Antártida' },
          { name: 'Antígua e Barbuda', value: 'Antígua e Barbuda' },
          { name: 'Argentina', value: 'Argentina' },
          { name: 'Armênia', value: 'Armênia' },
          { name: 'Aruba', value: 'Aruba' },
          { name: 'Austrália', value: 'Austrália' },
          { name: 'Azerbaijão', value: 'Azerbaijão' },
          { name: 'Bahamas', value: 'Bahamas' },
          { name: 'Bahrein', value: 'Bahrein' },
          { name: 'Bangladesh', value: 'Bangladesh' },
          { name: 'Barbados', value: 'Barbados' },
          { name: 'Belarus', value: 'Belarus' },
          { name: 'Belize', value: 'Belize' },
          { name: 'Benin', value: 'Benin' },
          { name: 'Bermuda', value: 'Bermuda' },
          { name: 'Butão', value: 'Butão' },
          { name: 'Bolívia', value: 'Bolívia' },
          {
            name: 'Bonaire, Sint Eustatius e Saba',
            value: 'Bonaire, Sint Eustatius e Saba'
          },
          { name: 'Bósnia e Herzegovina', value: 'Bósnia e Herzegovina' },
          { name: 'Botsuana', value: 'Botsuana' },
          { name: 'Ilha Bouvet', value: 'Ilha Bouvet' },
          { name: 'Brasil', value: 'Brasil' },
          {
            name: 'Território Britânico do Oceano Índico',
            value: 'Território Britânico do Oceano Índico'
          },
          { name: 'Brunei', value: 'Brunei' },
          { name: 'Burquina Faso', value: 'Burquina Faso' },
          { name: 'Burundi', value: 'Burundi' },
          { name: 'Cabo Verde', value: 'Cabo Verde' },
          { name: 'Camboja', value: 'Camboja' },
          { name: 'Camarões', value: 'Camarões' },
          { name: 'Canadá', value: 'Canadá' },
          { name: 'Ilhas Cayman', value: 'Ilhas Cayman' },
          {
            name: 'República Centro-Africana',
            value: 'República Centro-Africana'
          },
          { name: 'Chade', value: 'Chade' },
          { name: 'Chile', value: 'Chile' },
          { name: 'China', value: 'China' },
          { name: 'Ilha Christmas', value: 'Ilha Christmas' },
          { name: 'Ilhas Cocos', value: 'Ilhas Cocos' },
          { name: 'Colômbia', value: 'Colômbia' },
          { name: 'Comores', value: 'Comores' },
          { name: 'Congo', value: 'Congo' },
          {
            name: 'República Democrática do Congo',
            value: 'República Democrática do Congo'
          },
          { name: 'Ilhas Cook', value: 'Ilhas Cook' },
          { name: 'Costa Rica', value: 'Costa Rica' },
          { name: 'Costa do Marfim', value: 'Costa do Marfim' },
          { name: 'Croácia', value: 'Croácia' },
          { name: 'Cuba', value: 'Cuba' },
          { name: 'Curaçao', value: 'Curaçao' },
          { name: 'Chipre', value: 'Chipre' },
          { name: 'Djibouti', value: 'Djibouti' },
          { name: 'Dominica', value: 'Dominica' },
          { name: 'República Dominicana', value: 'República Dominicana' },
          { name: 'Equador', value: 'Equador' },
          { name: 'Egito', value: 'Egito' },
          { name: 'El Salvador', value: 'El Salvador' },
          { name: 'Guiné Equatorial', value: 'Guiné Equatorial' },
          { name: 'Eritreia', value: 'Eritreia' },
          { name: 'Eswatini', value: 'Eswatini' },
          { name: 'Etiópia', value: 'Etiópia' },
          { name: 'Ilhas Malvinas', value: 'Ilhas Malvinas' },
          { name: 'Ilhas Faroe', value: 'Ilhas Faroe' },
          { name: 'Fiji', value: 'Fiji' },
          {
            name: 'Ilhas Geórgia do Sul e Sandwich do Sul',
            value: 'Ilhas Geórgia do Sul e Sandwich do Sul'
          },
          { name: 'Guam', value: 'Guam' },
          { name: 'Guatemala', value: 'Guatemala' },
          { name: 'Guernsey', value: 'Guernsey' },
          { name: 'Guiné', value: 'Guiné' },
          { name: 'Guiné-Bissau', value: 'Guiné-Bissau' },
          { name: 'Guiana', value: 'Guiana' },
          { name: 'Haiti', value: 'Haiti' },
          {
            name: 'Ilha Heard e Ilhas McDonald',
            value: 'Ilha Heard e Ilhas McDonald'
          },
          { name: 'Santa Sé', value: 'Santa Sé' },
          { name: 'Honduras', value: 'Honduras' },
          { name: 'Hong Kong', value: 'Hong Kong' },
          { name: 'Islândia', value: 'Islândia' },
          { name: 'Índia', value: 'Índia' },
          { name: 'Indonésia', value: 'Indonésia' },
          { name: 'Irã', value: 'Irã' },
          { name: 'Iraque', value: 'Iraque' },
          { name: 'Israel', value: 'Israel' },
          { name: 'Jamaica', value: 'Jamaica' },
          { name: 'Japão', value: 'Japão' },
          { name: 'Jersey', value: 'Jersey' },
          { name: 'Jordânia', value: 'Jordânia' },
          { name: 'Cazaquistão', value: 'Cazaquistão' },
          { name: 'Quênia', value: 'Quênia' },
          { name: 'Kiribati', value: 'Kiribati' },
          { name: 'Coreia do Norte', value: 'Coreia do Norte' },
          { name: 'Coreia do Sul', value: 'Coreia do Sul' },
          { name: 'Kuwait', value: 'Kuwait' },
          { name: 'Quirguistão', value: 'Quirguistão' },
          { name: 'Laos', value: 'Laos' },
          { name: 'Líbano', value: 'Líbano' },
          { name: 'Lesoto', value: 'Lesoto' },
          { name: 'Libéria', value: 'Libéria' },
          { name: 'Líbia', value: 'Líbia' },
          { name: 'Macau', value: 'Macau' },
          { name: 'Madagascar', value: 'Madagascar' },
          { name: 'Malawi', value: 'Malawi' },
          { name: 'Malásia', value: 'Malásia' },
          { name: 'Maldivas', value: 'Maldivas' },
          { name: 'Mali', value: 'Mali' },
          { name: 'Malta', value: 'Malta' },
          { name: 'Ilhas Marshall', value: 'Ilhas Marshall' },
          { name: 'Mauritânia', value: 'Mauritânia' },
          { name: 'Maurícia', value: 'Maurícia' },
          { name: 'México', value: 'México' },
          { name: 'Micronésia', value: 'Micronésia' },
          { name: 'Moldávia', value: 'Moldávia' },
          { name: 'Mônaco', value: 'Mônaco' },
          { name: 'Mongólia', value: 'Mongólia' },
          { name: 'Montserrat', value: 'Montserrat' },
          { name: 'Marrocos', value: 'Marrocos' },
          { name: 'Moçambique', value: 'Moçambique' },
          { name: 'Mianmar', value: 'Mianmar' },
          { name: 'Namíbia', value: 'Namíbia' },
          { name: 'Nauru', value: 'Nauru' },
          { name: 'Nepal', value: 'Nepal' },
          { name: 'Antilhas Holandesas', value: 'Antilhas Holandesas' },
          { name: 'Nova Caledônia', value: 'Nova Caledônia' },
          { name: 'Nova Zelândia', value: 'Nova Zelândia' },
          { name: 'Nicarágua', value: 'Nicarágua' },
          { name: 'Níger', value: 'Níger' },
          { name: 'Nigéria', value: 'Nigéria' },
          { name: 'Niue', value: 'Niue' },
          { name: 'Ilha Norfolk', value: 'Ilha Norfolk' },
          { name: 'Ilhas Marianas do Norte', value: 'Ilhas Marianas do Norte' },
          { name: 'Noruega', value: 'Noruega' },
          { name: 'Omã', value: 'Omã' },
          { name: 'Paquistão', value: 'Paquistão' },
          { name: 'Palau', value: 'Palau' },
          { name: 'Palestina', value: 'Palestina' },
          { name: 'Panamá', value: 'Panamá' },
          { name: 'Papua-Nova Guiné', value: 'Papua-Nova Guiné' },
          { name: 'Paraguai', value: 'Paraguai' },
          { name: 'Peru', value: 'Peru' },
          { name: 'Filipinas', value: 'Filipinas' },
          { name: 'Pitcairn', value: 'Pitcairn' },
          { name: 'Porto Rico', value: 'Porto Rico' },
          { name: 'Catar', value: 'Catar' },
          { name: 'Reunião', value: 'Reunião' },
          { name: 'Rússia', value: 'Rússia' },
          { name: 'Ruanda', value: 'Ruanda' },
          { name: 'São Bartolomeu', value: 'São Bartolomeu' },
          { name: 'Santa Helena', value: 'Santa Helena' },
          { name: 'São Cristóvão e Nevis', value: 'São Cristóvão e Nevis' },
          { name: 'Santa Lúcia', value: 'Santa Lúcia' },
          { name: 'São Martinho', value: 'São Martinho' },
          { name: 'São Pedro e Miquelão', value: 'São Pedro e Miquelão' },
          {
            name: 'São Vicente e Granadinas',
            value: 'São Vicente e Granadinas'
          },
          { name: 'Samoa', value: 'Samoa' },
          { name: 'San Marino', value: 'San Marino' },
          { name: 'São Tomé e Príncipe', value: 'São Tomé e Príncipe' },
          { name: 'Arábia Saudita', value: 'Arábia Saudita' },
          { name: 'Senegal', value: 'Senegal' },
          { name: 'Seicheles', value: 'Seicheles' },
          { name: 'Serra Leoa', value: 'Serra Leoa' },
          { name: 'Singapura', value: 'Singapura' },
          { name: 'Ilhas Salomão', value: 'Ilhas Salomão' },
          { name: 'Somália', value: 'Somália' },
          { name: 'África do Sul', value: 'África do Sul' },
          {
            name: 'Ilhas Geórgias do Sul e Sandwich do Sul',
            value: 'Ilhas Geórgias do Sul e Sandwich do Sul'
          },
          { name: 'Sudão do Sul', value: 'Sudão do Sul' },
          { name: 'Sri Lanka', value: 'Sri Lanka' },
          { name: 'Sudão', value: 'Sudão' },
          { name: 'Suriname', value: 'Suriname' },
          { name: 'Svalbard e Jan Mayen', value: 'Svalbard e Jan Mayen' },
          { name: 'Síria', value: 'Síria' },
          { name: 'Taiwan', value: 'Taiwan' },
          { name: 'Tajiquistão', value: 'Tajiquistão' },
          { name: 'Tanzânia', value: 'Tanzânia' },
          { name: 'Tailândia', value: 'Tailândia' },
          { name: 'Timor-Leste', value: 'Timor-Leste' },
          { name: 'Togo', value: 'Togo' },
          { name: 'Tokelau', value: 'Tokelau' },
          { name: 'Tonga', value: 'Tonga' },
          { name: 'Trinidad e Tobago', value: 'Trinidad e Tobago' },
          { name: 'Tunísia', value: 'Tunísia' },
          { name: 'Turquia', value: 'Turquia' },
          { name: 'Turcomenistão', value: 'Turcomenistão' },
          { name: 'Ilhas Turks e Caicos', value: 'Ilhas Turks e Caicos' },
          { name: 'Tuvalu', value: 'Tuvalu' },
          { name: 'Uganda', value: 'Uganda' },
          { name: 'Ucrânia', value: 'Ucrânia' },
          { name: 'Emirados Árabes Unidos', value: 'Emirados Árabes Unidos' },
          { name: 'Estados Unidos', value: 'Estados Unidos' },
          {
            name: 'Ilhas Menores Distantes dos Estados Unidos',
            value: 'Ilhas Menores Distantes dos Estados Unidos'
          },
          { name: 'Uruguai', value: 'Uruguai' },
          { name: 'Uzbequistão', value: 'Uzbequistão' },
          { name: 'Vanuatu', value: 'Vanuatu' },
          { name: 'Venezuela', value: 'Venezuela' },
          { name: 'Vietnã', value: 'Vietnã' },
          {
            name: 'Ilhas Virgens Britânicas',
            value: 'Ilhas Virgens Britânicas'
          },
          {
            name: 'Ilhas Virgens Americanas',
            value: 'Ilhas Virgens Americanas'
          },
          { name: 'Wallis e Futuna', value: 'Wallis e Futuna' },
          { name: 'Saara Ocidental', value: 'Saara Ocidental' },
          { name: 'Iêmen', value: 'Iêmen' },
          { name: 'Zâmbia', value: 'Zâmbia' },
          { name: 'Zimbábue', value: 'Zimbábue' }
        ],
        englishCountriesArray: [
          { name: 'Afghanistan', value: 'Afghanistan' },
          { name: 'American Samoa', value: 'American Samoa' },
          { name: 'Anguilla', value: 'Anguilla' },
          { name: 'Antarctica', value: 'Antarctica' },
          { name: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
          { name: 'Argentina', value: 'Argentina' },
          { name: 'Armenia', value: 'Armenia' },
          { name: 'Aruba', value: 'Aruba' },
          { name: 'Australia', value: 'Australia' },
          { name: 'Azerbaijan', value: 'Azerbaijan' },
          { name: 'Bahamas', value: 'Bahamas' },
          { name: 'Bahrain', value: 'Bahrain' },
          { name: 'Bangladesh', value: 'Bangladesh' },
          { name: 'Barbados', value: 'Barbados' },
          { name: 'Belarus', value: 'Belarus' },
          { name: 'Belize', value: 'Belize' },
          { name: 'Benin', value: 'Benin' },
          { name: 'Bermuda', value: 'Bermuda' },
          { name: 'Bhutan', value: 'Bhutan' },
          { name: 'Bolivia', value: 'Bolivia' },
          {
            name: 'Bonaire, Sint Eustatius and Saba',
            value: 'Bonaire, Sint Eustatius and Saba'
          },
          { name: 'Botswana', value: 'Botswana' },
          { name: 'Bouvet Island', value: 'Bouvet Island' },
          { name: 'Brazil', value: 'Brazil' },
          {
            name: 'British Indian Ocean Territory',
            value: 'British Indian Ocean Territory'
          },
          { name: 'Brunei', value: 'Brunei' },
          { name: 'Burkina Faso', value: 'Burkina Faso' },
          { name: 'Burundi', value: 'Burundi' },
          { name: 'Cape Verde', value: 'Cape Verde' },
          { name: 'Cambodia', value: 'Cambodia' },
          { name: 'Cameroon', value: 'Cameroon' },
          { name: 'Canada', value: 'Canada' },
          { name: 'Cayman Islands', value: 'Cayman Islands' },
          {
            name: 'Central African Republic',
            value: 'Central African Republic'
          },
          { name: 'Chad', value: 'Chad' },
          { name: 'Chile', value: 'Chile' },
          { name: 'China', value: 'China' },
          { name: 'Christmas Island', value: 'Christmas Island' },
          { name: 'Cocos Islands', value: 'Cocos Islands' },
          { name: 'Colombia', value: 'Colombia' },
          { name: 'Comoros', value: 'Comoros' },
          { name: 'Congo', value: 'Congo' },
          {
            name: 'Democratic Republic of the Congo',
            value: 'Democratic Republic of the Congo'
          },
          { name: 'Cook Islands', value: 'Cook Islands' },
          { name: 'Costa Rica', value: 'Costa Rica' },
          { name: 'Ivory Coast', value: 'Ivory Coast' },
          { name: 'Croatia', value: 'Croatia' },
          { name: 'Cuba', value: 'Cuba' },
          { name: 'Curacao', value: 'Curacao' },
          { name: 'Cyprus', value: 'Cyprus' },
          { name: 'Djibouti', value: 'Djibouti' },
          { name: 'Dominica', value: 'Dominica' },
          { name: 'Dominican Republic', value: 'Dominican Republic' },
          { name: 'Ecuador', value: 'Ecuador' },
          { name: 'Egypt', value: 'Egypt' },
          { name: 'El Salvador', value: 'El Salvador' },
          { name: 'Equatorial Guinea', value: 'Equatorial Guinea' },
          { name: 'Eritrea', value: 'Eritrea' },
          { name: 'Eswatini', value: 'Eswatini' },
          { name: 'Ethiopia', value: 'Ethiopia' },
          { name: 'Falkland Islands', value: 'Falkland Islands' },
          { name: 'Faroe Islands', value: 'Faroe Islands' },
          { name: 'Fiji', value: 'Fiji' },
          {
            name: 'South Georgia and the South Sandwich Islands',
            value: 'South Georgia and the South Sandwich Islands'
          },
          { name: 'Guam', value: 'Guam' },
          { name: 'Guatemala', value: 'Guatemala' },
          { name: 'Guernsey', value: 'Guernsey' },
          { name: 'Guinea', value: 'Guinea' },
          { name: 'Guinea-Bissau', value: 'Guinea-Bissau' },
          { name: 'Guyana', value: 'Guyana' },
          { name: 'Haiti', value: 'Haiti' },
          {
            name: 'Heard Island and McDonald Islands',
            value: 'Heard Island and McDonald Islands'
          },
          { name: 'Honduras', value: 'Honduras' },
          { name: 'Hong Kong', value: 'Hong Kong' },
          { name: 'Iceland', value: 'Iceland' },
          { name: 'India', value: 'India' },
          { name: 'Indonesia', value: 'Indonesia' },
          { name: 'Iran', value: 'Iran' },
          { name: 'Iraq', value: 'Iraq' },
          { name: 'Israel', value: 'Israel' },
          { name: 'Jamaica', value: 'Jamaica' },
          { name: 'Japan', value: 'Japan' },
          { name: 'Jersey', value: 'Jersey' },
          { name: 'Jordan', value: 'Jordan' },
          { name: 'Kazakhstan', value: 'Kazakhstan' },
          { name: 'Kenya', value: 'Kenya' },
          { name: 'Kiribati', value: 'Kiribati' },
          { name: 'North Korea', value: 'North Korea' },
          { name: 'South Korea', value: 'South Korea' },
          { name: 'Kuwait', value: 'Kuwait' },
          { name: 'Kyrgyzstan', value: 'Kyrgyzstan' },
          { name: 'Laos', value: 'Laos' },
          { name: 'Lebanon', value: 'Lebanon' },
          { name: 'Lesotho', value: 'Lesotho' },
          { name: 'Liberia', value: 'Liberia' },
          { name: 'Libya', value: 'Libya' },
          { name: 'Macao', value: 'Macao' },
          { name: 'Madagascar', value: 'Madagascar' },
          { name: 'Malawi', value: 'Malawi' },
          { name: 'Malaysia', value: 'Malaysia' },
          { name: 'Maldives', value: 'Maldives' },
          { name: 'Mali', value: 'Mali' },
          { name: 'Malta', value: 'Malta' },
          { name: 'Marshall Islands', value: 'Marshall Islands' },
          { name: 'Mauritania', value: 'Mauritania' },
          { name: 'Mauritius', value: 'Mauritius' },
          { name: 'Mexico', value: 'Mexico' },
          { name: 'Micronesia', value: 'Micronesia' },
          { name: 'Moldova', value: 'Moldova' },
          { name: 'Monaco', value: 'Monaco' },
          { name: 'Mongolia', value: 'Mongolia' },
          { name: 'Montserrat', value: 'Montserrat' },
          { name: 'Morocco', value: 'Morocco' },
          { name: 'Mozambique', value: 'Mozambique' },
          { name: 'Myanmar', value: 'Myanmar' },
          { name: 'Namibia', value: 'Namibia' },
          { name: 'Nauru', value: 'Nauru' },
          { name: 'Nepal', value: 'Nepal' },
          { name: 'Netherlands Antilles', value: 'Netherlands Antilles' },
          { name: 'New Caledonia', value: 'New Caledonia' },
          { name: 'New Zealand', value: 'New Zealand' },
          { name: 'Nicaragua', value: 'Nicaragua' },
          { name: 'Niger', value: 'Niger' },
          { name: 'Nigeria', value: 'Nigeria' },
          { name: 'Niue', value: 'Niue' },
          { name: 'Norfolk Island', value: 'Norfolk Island' },
          {
            name: 'Northern Mariana Islands',
            value: 'Northern Mariana Islands'
          },
          { name: 'Norway', value: 'Norway' },
          { name: 'Oman', value: 'Oman' },
          { name: 'Pakistan', value: 'Pakistan' },
          { name: 'Palau', value: 'Palau' },
          { name: 'Palestine', value: 'Palestine' },
          { name: 'Panama', value: 'Panama' },
          { name: 'Papua New Guinea', value: 'Papua New Guinea' },
          { name: 'Paraguay', value: 'Paraguay' },
          { name: 'Peru', value: 'Peru' },
          { name: 'Philippines', value: 'Philippines' },
          { name: 'Pitcairn', value: 'Pitcairn' },
          { name: 'Puerto Rico', value: 'Puerto Rico' },
          { name: 'Qatar', value: 'Qatar' },
          { name: 'Reunion', value: 'Reunion' },
          { name: 'Russia', value: 'Russia' },
          { name: 'Rwanda', value: 'Rwanda' },
          { name: 'Saint Barthelemy', value: 'Saint Barthelemy' },
          { name: 'Saint Helena', value: 'Saint Helena' },
          { name: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
          { name: 'Saint Lucia', value: 'Saint Lucia' },
          { name: 'Saint Martin', value: 'Saint Martin' },
          {
            name: 'Saint Pierre and Miquelon',
            value: 'Saint Pierre and Miquelon'
          },
          {
            name: 'Saint Vincent and the Grenadines',
            value: 'Saint Vincent and the Grenadines'
          },
          { name: 'Samoa', value: 'Samoa' },
          { name: 'San Marino', value: 'San Marino' },
          { name: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
          { name: 'Saudi Arabia', value: 'Saudi Arabia' },
          { name: 'Senegal', value: 'Senegal' },
          { name: 'Seychelles', value: 'Seychelles' },
          { name: 'Sierra Leone', value: 'Sierra Leone' },
          { name: 'Singapore', value: 'Singapore' },
          { name: 'Sint Maarten', value: 'Sint Maarten' },
          { name: 'Solomon Islands', value: 'Solomon Islands' },
          { name: 'Somalia', value: 'Somalia' },
          { name: 'South Africa', value: 'South Africa' },
          {
            name: 'South Georgia and the South Sandwich Islands',
            value: 'South Georgia and the South Sandwich Islands'
          },
          { name: 'South Sudan', value: 'South Sudan' },
          { name: 'Sri Lanka', value: 'Sri Lanka' },
          { name: 'Sudan', value: 'Sudan' },
          { name: 'Suriname', value: 'Suriname' },
          { name: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' },
          { name: 'Syria', value: 'Syria' },
          { name: 'Taiwan', value: 'Taiwan' },
          { name: 'Tajikistan', value: 'Tajikistan' },
          { name: 'Tanzania', value: 'Tanzania' },
          { name: 'Thailand', value: 'Thailand' },
          { name: 'Timor-Leste', value: 'Timor-Leste' },
          { name: 'Togo', value: 'Togo' },
          { name: 'Tokelau', value: 'Tokelau' },
          { name: 'Tonga', value: 'Tonga' },
          { name: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
          { name: 'Tunisia', value: 'Tunisia' },
          { name: 'Turkey', value: 'Turkey' },
          { name: 'Turkmenistan', value: 'Turkmenistan' },
          {
            name: 'Turks and Caicos Islands',
            value: 'Turks and Caicos Islands'
          },
          { name: 'Tuvalu', value: 'Tuvalu' },
          { name: 'Uganda', value: 'Uganda' },
          { name: 'Ukraine', value: 'Ukraine' },
          { name: 'United Arab Emirates', value: 'United Arab Emirates' },
          { name: 'United States', value: 'United States' },
          {
            name: 'United States Minor Outlying Islands',
            value: 'United States Minor Outlying Islands'
          },
          { name: 'Uruguay', value: 'Uruguay' },
          { name: 'Uzbekistan', value: 'Uzbekistan' },
          { name: 'Vanuatu', value: 'Vanuatu' },
          { name: 'Venezuela', value: 'Venezuela' },
          { name: 'Vietnam', value: 'Vietnam' },
          { name: 'British Virgin Islands', value: 'British Virgin Islands' },
          { name: 'U.S. Virgin Islands', value: 'U.S. Virgin Islands' },
          { name: 'Wallis and Futuna', value: 'Wallis and Futuna' },
          { name: 'Western Sahara', value: 'Western Sahara' },
          { name: 'Yemen', value: 'Yemen' },
          { name: 'Zambia', value: 'Zambia' },
          { name: 'Zimbabwe', value: 'Zimbabwe' }
        ],
        countryCode: [
          {
            value: '+244',
            name: 'AO (+244)' // Angola
          },
          {
            value: '+43',
            name: 'AT (+43)' // Austria
          },
          {
            value: '+32',
            name: 'BE (+32)' // Belgium
          },
          {
            value: '+55',
            name: 'BR (+55)' // Brazil
          },
          {
            value: '+359',
            name: 'BG (+359)' // Bulgaria
          },
          {
            value: '+238',
            name: 'CV (+238)' // Cape Verde
          },
          {
            value: '+385',
            name: 'HR (+385)' // Croatia
          },
          {
            value: '+357',
            name: 'CY (+357)' // Cyprus
          },
          {
            value: '+420',
            name: 'CZ (+420)' // Czech Republic
          },
          {
            value: '+45',
            name: 'DK (+45)' // Denmark
          },
          {
            value: '+372',
            name: 'EE (+372)' // Estonia
          },
          {
            value: '+358',
            name: 'FI (+358)' // Finland
          },
          {
            value: '+33',
            name: 'FR (+33)' // France
          },
          {
            value: '+49',
            name: 'DE (+49)' // Germany
          },
          {
            value: '+30',
            name: 'GR (+30)' // Greece
          },
          {
            value: '+245',
            name: 'GW (+245)' // Guinea-Bissau
          },
          {
            value: '+36',
            name: 'HU (+36)' // Hungary
          },
          {
            value: '+353',
            name: 'IE (+353)' // Ireland
          },
          {
            value: '+39',
            name: 'IT (+39)' // Italy
          },
          {
            value: '+371',
            name: 'LV (+371)' // Latvia
          },
          {
            value: '+423',
            name: 'LI (+423)' // Liechtenstein
          },
          {
            value: '+370',
            name: 'LT (+370)' // Lithuania
          },
          {
            value: '+352',
            name: 'LU (+352)' // Luxembourg
          },
          {
            value: '+356',
            name: 'MT (+356)' // Malta
          },
          {
            value: '+258',
            name: 'MZ (+258)' // Mozambique
          },
          {
            value: '+31',
            name: 'NL (+31)' // Netherlands
          },
          {
            value: '+48',
            name: 'PL (+48)' // Poland
          },
          {
            value: '+351',
            name: 'PT (+351)' // Portugal
          },
          {
            value: '+40',
            name: 'RO (+40)' // Romania
          },
          {
            value: '+239',
            name: 'ST (+239)' // São Tomé and Príncipe
          },
          {
            value: '+421',
            name: 'SK (+421)' // Slovakia
          },
          {
            value: '+386',
            name: 'SI (+386)' // Slovenia
          },
          {
            value: '+34',
            name: 'ES (+34)' // Spain
          },
          {
            value: '+46',
            name: 'SE (+46)' // Sweden
          },
          {
            value: '+41',
            name: 'CH (+41)' // Switzerland
          },
          {
            value: '+44',
            name: 'UK (+44)' // United Kingdom
          },
          {
            value: '+1',
            name: 'USA (+1)' // United States
          }
        ],
        location: [
          {
            value: 'Europa',
            name: this.$i18n.t('Europe')
          },
          {
            value: 'Mundo',
            name: this.$i18n.t('World')
          }
        ],
        duration: [
          {
            value: 'Até 1 Mês',
            name: this.$i18n.t('Up to 1 Month')
          },
          {
            value: 'De 1 a 2 Meses',
            name: this.$i18n.t('From 1 to 2 Months')
          },
          {
            value: 'De 2 a 3 Meses',
            name: this.$i18n.t('From 2 to 3 Months')
          },
          {
            value: 'De 3 a 6 Meses',
            name: this.$i18n.t('From 3 to 6 Months')
          },
          {
            value: 'De 6 a 9 Meses',
            name: this.$i18n.t('From 6 to 9 Months')
          },
          {
            value: 'anual',
            name: this.$i18n.t('Annual')
          }
        ]
      }
    }
  },

  computed: {
    firstName() {
      // Split the fullName into first name and last name
      return this.fullName.split(' ')[0] || ''
    },
    lastName() {
      // Split the fullName into first name and last name
      return (
        this.fullName
          .split(' ')
          .slice(1)
          .join(' ') || ''
      )
    },
    getCountryCode() {
      return this.countryCode
    },
    personalDetails() {
      return {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.countryCode + this.phone,
        applicantDateOfBirth: this.applicantDateOfBirth,
        location: this.location,
        start_date: this.start_date,
        country: this.country,
        end_date: this.end_date
      }
    }
  },

  validations() {
    const baseValidation = {
      fullName: {
        required,
        minLength: minLength(2),
        custom(value) {
          const names = value.split(' ')
          return names.length >= 2 && names.every((name) => name.length >= 2)
        }
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        phoneRule: (value) => phoneRule(value, this.countryCode)
      },
      applicantDateOfBirth: {
        required,
        isLessThanToday,
        isDateLessThan: isDateLessThan(67)
      },
      privacyPolicy: {
        required,
        sameAs
      },
      termsAndConditions: {
        required,
        sameAs
      },
      location: {
        required
      },
      start_date: {
        required,
        isAtLeastNextDayRule: (value) => isAtLeastNextDayRule(value)
      },
      end_date: {
        required,
        isSecondDateGreaterThanFirstRule: (value) =>
          isSecondDateGreaterThanFirstRule(this.start_date, value)
      },
      countryCode: {
        required
      }
    }
    return baseValidation
  },

  methods: {
    getArrayOfCountries() {
      if (this.$i18n.locale === 'pt') {
        return this.options.portugueseCountriesArray
      } else {
        return this.options.englishCountriesArray
      }
    },
    focusNextInput(ref) {
      this.$nextTick(() => {
        this.$refs[ref].$el.querySelector('input').focus()
      })
    },
    validateForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => this.goToFirstError())
      }
    },
    goToNextStep() {
      this.validateForm()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('input', this.personalDetails)
    },
    scrollTo(element) {
      const elementPosition =
        element.getBoundingClientRect().top + document.documentElement.scrollTop
      const halfOfViewport =
        Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        ) / 2

      window.scrollTo(0, elementPosition - halfOfViewport)
    }
  }
}
